import "antd/dist/antd.css";
import Cohere from "cohere-js";
import { AppWrapper } from "./styles";
import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./style.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "typeface-roboto";
import { store } from "./modules/store";
import { Provider } from "react-redux";
import { CookiesProvider } from "react-cookie";
import RoutesComponent from "./components/Route/RoutesComponent";
import { IntercomProvider } from "react-use-intercom";
import PaywallPopup from "./components/Paywall Popup/PaywallPopup";

const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === "[::1]" ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

// Assuming you have two redirect URIs, and the first is for localhost and second is for production

Cohere.init("HQf0t6g6lLJn7jIIxqDeuL7q");
const INTERCOM_APP_ID = "at0ppvof";
const App = () => {
  return (
    <Provider store={store}>
      <CookiesProvider>
        <IntercomProvider appId={INTERCOM_APP_ID} autoBoot>
          <AppWrapper>
            <Router>
              <RoutesComponent />
            </Router>
          </AppWrapper>
        </IntercomProvider>
      </CookiesProvider>
    </Provider>
  );
};

export default App;
